var map = {
	"./hp_default.json": [
		99052,
		9052
	],
	"./hp_french.json": [
		38303,
		8303
	],
	"./hp_german.json": [
		305,
		305
	],
	"./hp_spanish.json": [
		99286,
		9286
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59853;
module.exports = webpackAsyncContext;